(function() {

    _.mixin({
        symmDifference: function (x, y) {
            return _.union(_.difference(x, y), _.difference(y, x));
        },
        wrapArray: function (x) {
            return _.isArray(x) ? x : [x];
        },
        pop: function (obj, key) {
            var value = obj[key];
            delete obj[key];
            return value;
        },
        // like python itertools compress
        compress: function (array, selectors) {
            return _.filter(array, function (x, i) {
                return selectors[i] || false;
            });
        },
        // from underscore.js 1.9.0
        chunk: function (array, count) {
            if (!count || count < 1) {
                return [];
            }
            var result = [];
            var i = 0, length = array.length;
            while (i < length) {
                result.push(array.slice(i, i += count));
            }
            return result;
        }
    });

}).call(this);
